import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";
import { server } from "../config/config";

const BASE_EVENT = "events-service/events";

const RESOURCES = {
	LIST_CONDOMINIO_EVENTS_PAGINATED: (page, condominioId, filters, orderBy, fetchUsers, rowsPerPage) => {
		console.log(filters);
		const params = {
			page,
			idCondominio: condominioId,
			search: filters.search ?? "",
			name: filters.name ?? "",
			type: filters.eventType,
			startDate: filters.startDate,
			endDate: filters.endDate,
			startTime: filters.startTime ?? '',
			endTime: filters.endTime ?? '',
			continuousInterval: filters.continuousInterval ?? false,
			licence: filters.licence ?? "",
			detail: filters.detail ?? "",
			data: filters.data ?? "",
			user: filters.user ?? "",
			uuid: filters.uuid ?? "",
			result: filters.result ?? "",
			info: filters.info ?? "",
			carName: filters.carName,
			carBrand: filters.carBrand,
			carColor: filters.carColor,
			carPlate: filters.carPlate,
			orderBy: orderBy.collumnTitle,
			orderDirection: orderBy.orderDirection,
			fetchUsers,
			rowsPerPage,
		};
		if (filters.targetNotEmpty != null) {
			params.targetNotEmpty = filters.targetNotEmpty;
		}
		const searchParams = new URLSearchParams(params);
		return `${BASE_EVENT}/paginated?${searchParams.toString()}`;
	},

	LIST_CONDOMINIO_EVENTS: (condominioId, filters, orderBy, fetchUsers) => {
		const searchParam = new URLSearchParams({
			idCondominio: condominioId,
			...filters,
			...orderBy,
			fetchUsers,
		});
		return `${BASE_EVENT}?${searchParam.toString()}`;
	},

	DOWNLOAD_CSV_WITH_FILTERS: (condominioId, filters) => {
		const searchParams = new URLSearchParams();
		searchParams.set("idCondominio", condominioId);

		const queryFilters = {
			search: filters.search,
			name: filters.name,
			type: filters.eventType,
			startDate: filters.startDate,
			endDate: filters.endDate,
			startTime: filters.startTime,
			endTime: filters.endTime,
			continuousInterval: filters.continuousInterval,
			licence: filters.licence,
			detail: filters.detail,
			data: filters.data,
			user: filters.user,
			uuid: filters.uuid,
			result: filters.result,
			info: filters.info,
			carName: filters.carName,
			carBrand: filters.carBrand,
			carColor: filters.carColor,
			carPlate: filters.carPlate,
		};
		Object.entries(queryFilters).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== "") {
				searchParams.set(key, value);
			}
		});
		return `${BASE_EVENT}/download-csv?${searchParams.toString()}`;
	},
};

class EventsService {
	static async listCondominioEventsPaginated(
		page,
		condominioId,
		filters,
		orderBy,
		fetchUsers,
		rowsPerPage = 8,
		cancelToken,
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_CONDOMINIO_EVENTS_PAGINATED(
					page,
					condominioId,
					filters,
					orderBy,
					fetchUsers,
					rowsPerPage,
				),
				{
					signal: cancelToken
				}
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar eventos",
			});
			return error.response;
		}
	}

	static async listCondominioEvents(
		condominioId,
		filters,
		orderBy,
		fetchUsers,
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_CONDOMINIO_EVENTS(
					condominioId,
					filters,
					orderBy,
					fetchUsers,
				),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar eventos",
			});
			return error.response;
		}
	}

	static async listViolationsAndPanics(
		condominioId,
	) {
		try {
			return await axios.get(`${BASE_EVENT}/violations-and-panics?idCondominio=${condominioId}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar eventos",
			});
			return error.response;
		}
	}

	static async finishAccessEvent(eventId, idCondominio) {
		try {
			return await axios.post(`${BASE_EVENT}/${idCondominio}/${eventId}/finish-access`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao criar evento de saída",
			});
			return error.response;
		}
	}

	static async downloadCsv(condominioId, filters) {
		const token = localStorage.getItem("@BRVAuth:token");
		const response = await fetch(
			`${server.url}/${RESOURCES.DOWNLOAD_CSV_WITH_FILTERS(condominioId, filters)}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);

		if (!response.ok) {
			const errorData = await response.json().catch(() => ({}));
			ResponseAlerts({
				response: { status: response.status, data: errorData },
				errorMessage: errorData?.message ?? "Erro ao realizar download csv",
			});
			return null;
		}

		return response;
	}

	static async getTodayAccessEventsByHour(condominioId, listMode = "all") {
		try {
			const params = new URLSearchParams({
				idCondominio: condominioId,
				listMode,
			});
			return await axios.get(`${BASE_EVENT}/reports/today-access-events-by-hour?${params.toString()}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar eventos",
			});
			return error.response;
		}
	}

	static async getCountAlarms(condominioId) {
		try {
			return await axios.get(`${BASE_EVENT}/reports/count-alarms?idCondominio=${condominioId}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter relatório de alarmes",
			});
			return error.response;
		}
	}

	static async getHardwareByUnit(idUnit) {
		try {
			return await axios.get(`events-service/hardwares/unit/${idUnit}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter hardware",
			});
			return error.response;
		}
	}

	static async listHardwaresByOrganization(idOrganization) {
		try {
			return await axios.get(`events-service/hardwares/organization/${idOrganization}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter hardwares da organização",
			});
			return error.response;
		}
	}

	static async updateEvent(id, payload) {
		return await axios
			.put(`${BASE_EVENT}/${id}`, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Atualizado com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar",
				});
				return error.response;
			});
	}

	static async finishBatchAlarms(query, payload) {
		return await axios
			.put(`${BASE_EVENT}/finish-batch-alarms?${new URLSearchParams(query).toString()}`, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Atualizado com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar",
				});
				return error.response;
			});
	}

	static async deleteBatchAlarms(query) {
		return await axios
			.delete(`${BASE_EVENT}/delete-batch-alarms?${new URLSearchParams(query).toString()}`)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Excluído com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response?.data?.message ?? "Erro ao excluir",
				});
				return error.response;
			});
	}

	static async getCountPendingAlarms(condominioId, signal = null) {
		try {
			return await axios.get(`${BASE_EVENT}/reports/count-pending-alarms?idCondominio=${condominioId}`, { signal });
		} catch (error) {
			if (signal && signal.aborted) {
				return;
			}
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter relatório de alarmes",
			});
			return error.response;
		}
	}

	static async getPresentUsers(condominioId, page = 1, rowsPerPage = 8, cancelToken) {
		try {
			return await axios.get(
				`${BASE_EVENT}/reports/users/presents?idCondominio=${condominioId}&page=${page}&rowsPerPage=${rowsPerPage}`,
				{
					signal: cancelToken,
					headers: {
						"Cache-Control": "no-cache",
					},
				}
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter relatório de presença",
			});
			return error.response;
		}
	}

	static async getPresenceUser(idUser, condominioId) {
		try {
			return await axios.get(
				`${BASE_EVENT}/reports/users/presence/${idUser}?idCondominio=${condominioId}`,
				{
					headers: {
						"Cache-Control": "no-cache",
					},
				}
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter relatório de presença",
			});
			return error.response;
		}
	}
}

export default EventsService;
